var React = require('react');

function HoursInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"cx":"12","cy":"12","r":"11","key":0}),React.createElement("path",{"d":"M13 5v8H8","key":1})]));
}

HoursInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = HoursInline;

HoursInline.default = HoursInline;
